import { Outlet } from 'react-router-dom'

import { EmployeesRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ContractsImporterProvider } from 'modules/employees/components/ContractImporter/contractsImporterContext'
import CollectionsBootstrap from 'modules/employees/lib/CollectionsBootstrap'
import { EmployeesImporterProvider } from 'modules/employees/lib/employeesImporterContext'
import jobLevelsCollection from 'modules/job_catalog/store/collections/levels'
import jobRolesCollection from 'modules/job_catalog/store/collections/roles'
import jobSalaryRangesCollection from 'modules/job_catalog/store/collections/salaryRanges'
import gendersCollection from 'modules/settings/store/collections/genders'
import legalGendersCollection from 'modules/settings/store/collections/legalGenders'

const Container = () => {
  const { company: currentCompany, employee } = useCurrentSession()

  const canSeeEmployees = employee ? employee.hasRegularAccess : true

  const { loading } = useAsyncData(
    () =>
      Promise.all([
        jobRolesCollection.fetch(),
        jobLevelsCollection.fetch(),
        jobSalaryRangesCollection.fetch(),
      ]),
    []
  )

  const { loading: loadingGenders } = useAsyncData(
    () => Promise.all([gendersCollection.fetch(), legalGendersCollection.fetch()]),
    []
  )

  const { loading: loadingModuleAvailabilities, moduleAvailabilities } = useModuleAvailabilities()

  const { loading: loadingPage, data: pageData } = useQuery(EmployeesRootPageDocument)

  const hasPerformanceFullVisiblity = Boolean(
    pageData?.performance?._policies?.reviewProcessFullVisibilityContextless?.can
  )

  return (
    <AuthorizeUser authorizeFn={() => canSeeEmployees}>
      <Outlet
        context={{
          loading: loading || loadingPage,
          loadingGenders,
          loadingModuleAvailabilities,
          moduleAvailabilities,
          hasPerformanceFullVisiblity,
        }}
      />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <EmployeesImporterProvider>
        <ContractsImporterProvider>
          <Container />
        </ContractsImporterProvider>
      </EmployeesImporterProvider>
    </CollectionsBootstrap>
  )
}

export default RootPage
